import { Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';
import { ExteriorInteriorGallerySpotModule } from './exterior-interior-gallery-spot.module';

@Component({
    selector: 'app-exterior-interior-gallery-spot',
    template: `
        <app-exterior-interior-gallery
            [text]="data.text"
            [buttonText]="data.buttonText"
            [vehicleModelId]="data.vehicleModel?.id"
        ></app-exterior-interior-gallery>
    `,
})
class ExteriorInteriorGallerySpotComponent {
    @Input() data: Cms.ExteriorInteriorGallerySpot;
}

@NgModule({
    declarations: [ExteriorInteriorGallerySpotComponent],
    imports: [ExteriorInteriorGallerySpotModule],
})
class ExteriorInteriorGallerySpotComponentModule {}

export const LazySpotComponent = ExteriorInteriorGallerySpotComponent;
